import {$http} from '@/utils/https'
import {
    MATERIALS_CHANGE_SKIP,
    MATERIALS_ITEM_REQUEST_STATUS,
    MATERIALS_REQUEST_STATUS,
    MATERIALS_SET_ITEM,
    MATERIALS_SET_LIST,
    MATERIALS_SET_LIST_LENGTH
} from './types/mutation-types';

import {FETCH_MATERIALS, FETCH_MATERIALS_ITEM} from './types/action-types';


const state = {
    list: [],
    currentItem: null,
    isListLoading: false,
    isCurrentItemLoading: false,
    skip: 0,
    limit: 9,
    listLength: 0,
    selectedVideoId: null
};

const getters = {
    list: state => state.list,
    currentItem: state => state.currentItem,
    listLength: state => state.listLength,
    skip: state => state.skip,
    isListLoading: state => state.isListLoading,
    isCurrentItemLoading: state => state.isCurrentItemLoading,
    selectedVideoId: state => state.selectedVideoId,
};

const actions = {
    [FETCH_MATERIALS]: async ({commit}, payload) => {
        try {
            commit(MATERIALS_REQUEST_STATUS, true);
            if (!payload.isNotFirstLoad) {
                commit(MATERIALS_SET_LIST, []);
                commit(MATERIALS_CHANGE_SKIP, true)
            } else commit(MATERIALS_CHANGE_SKIP);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/${payload.materialType}?skip=${state.skip}&limit=${state.limit}&include=image,image.seo,${payload.materialType === 'bonuses' ? 'authors' : 'speakers'}&use_as_id=slug`);

            payload.isNotFirstLoad || commit(MATERIALS_SET_LIST, []);
            commit(MATERIALS_SET_LIST, response.data.data);
            commit(MATERIALS_SET_LIST_LENGTH, response.data.meta.total);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(MATERIALS_REQUEST_STATUS, false);
        }
    },
    [FETCH_MATERIALS_ITEM]: async ({commit}, payload) => {
        try {
            commit(MATERIALS_ITEM_REQUEST_STATUS, true);
            commit(MATERIALS_SET_ITEM, null);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/${payload.materialType}/${payload.materialSlug}?include=image,image.seo,files,video,seo,video.chapters,${payload.materialType === 'bonuses' ? 'authors' : 'speakers'}&use_as_id=slug&filters[course]=${payload.item}`);
            commit(MATERIALS_SET_ITEM, null);
            commit(MATERIALS_SET_ITEM, response.data.data);

            const material = response.data.data;

            if (material.video.data.length) {
                commit('SET_VIDEO_ID', material.video.data[0].id)
            }

            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(MATERIALS_ITEM_REQUEST_STATUS, false);
        }
    },
};

const mutations = {
    [MATERIALS_SET_LIST](state, data) {
        if (!data.length) {
            state.list = data;
        } else {
            data.map(e => {
                if (e.hasOwnProperty('authors')) {
                    e.speakers = e.authors
                }
                return e
            });
        }
        !state.list.length ? state.list = data : state.list.push(...data);
    },
    [MATERIALS_SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },
    [MATERIALS_CHANGE_SKIP](state, status) {
        if (status) state.skip = 0;
        else state.skip += state.limit;
    },
    [MATERIALS_SET_ITEM](state, data) {
        if (data && data.hasOwnProperty('authors')) {
            data.speakers = data.authors
        }
        state.currentItem = data;
    },
    [MATERIALS_REQUEST_STATUS](state, status) {
        state.isListLoading = status;
    },
    [MATERIALS_ITEM_REQUEST_STATUS](state, status) {
        state.isCurrentItemLoading = status;
    },
    SET_VIDEO_ID(state, id) {
        state.selectedVideoId = id;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
